import React from "react";
import $ from "jquery";
import { decimalAdjust, TIPO_STOCK } from "../../Global";
import { extractTwoDecimalsForNumber } from "../../helpers/calcularVenta";
import {
    BotonAddPequeño,
    BotonDown,
    BotonMenosPequeño,
    BotonRemovePequeño,
    BotonMedirArea
} from "../Plantillas/Botones";
import Modal from "../Preventas/MedidasModal.js";
import { calculateAreaM2, calculateAreaPie2, calculateWasteM2, calculateWastePie2 } from "../../helpers/AreaCalculations";

export default class DetalleCotizaciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cantidadInput: 1,
            showAreaModal: false,
            selectedAreaItem: null,
            areaRows: [{ id: 1, cantidad: 1, ancho: "", alto: "" }],
            factorDesperdicio: 1.40,
            savedMeasurements: {}
        };
    }

    openAreaModal = (det) => {
        let savedData = this.state.savedMeasurements[det.IdPresentacion];

        if (!savedData && det.MedidasExtras) {
            try {
                savedData = JSON.parse(det.MedidasExtras);
                this.setState(prevState => ({
                    savedMeasurements: {
                        ...prevState.savedMeasurements,
                        [det.IdPresentacion]: savedData
                    }
                }));
            } catch (e) {
                console.error("Error al parsear MedidasExtras", e);
            }
        }

        this.setState({
            showAreaModal: true,
            selectedAreaItem: det,
            areaRows: savedData ? savedData.areaRows : [{ id: Date.now(), cantidad: 1, ancho: "", alto: "" }],
            factorDesperdicio: savedData ? savedData.factorDesperdicio : 1.40,
        });
    }

    closeAreaModal = () => {
        this.setState({
            showAreaModal: false,
            selectedAreaItem: null,
            areaRows: [{ id: 1, cantidad: 1, ancho: "", alto: "" }],
            factorDesperdicio: 1.40,
        });
    }

    handleAddRow = () => {
        const newRow = { id: Date.now(), cantidad: 1, ancho: "", alto: "" };
        this.setState(prevState => ({
            areaRows: [...prevState.areaRows, newRow]
        }));
    }

    handleRemoveRow = (id) => {
        this.setState(prevState => ({
            areaRows: prevState.areaRows.filter(row => row.id !== id)
        }));
    }

    handleRowChange = (id, field, value) => {
        this.setState(prevState => ({
            areaRows: prevState.areaRows.map(row =>
                row.id === id ? { ...row, [field]: value } : row
            )
        }));
    }

    handleFactorChange = (e) => {
        this.setState({ factorDesperdicio: e.target.value });
    }

    applyArea = () => {
        const { areaRows, selectedAreaItem, factorDesperdicio } = this.state;
        let totalM2 = 0;
        let totalPie2 = 0;

        areaRows.forEach((row, index) => {
            totalM2 += calculateAreaM2(row, factorDesperdicio);
            totalPie2 += calculateAreaPie2(row, factorDesperdicio);
        });

        const isPie = selectedAreaItem && (selectedAreaItem.unidadMedida || selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
        const finalArea = areaRows.reduce((sum, row) => {
            return sum + (isPie ? calculateAreaPie2(row, factorDesperdicio) : calculateAreaM2(row, factorDesperdicio));
        }, 0);

        if (finalArea > 0 && selectedAreaItem) {
            selectedAreaItem.MedidasExtras = JSON.stringify({
                areaRows: this.state.areaRows,
                factorDesperdicio: this.state.factorDesperdicio
            });

            this.props.InputCantidadDetalleChange({
                target: { value: decimalAdjust('round', finalArea, -2) }
            }, selectedAreaItem);

            this.setState(prevState => ({
                savedMeasurements: {
                    ...prevState.savedMeasurements,
                    [selectedAreaItem.IdPresentacion]: {
                        areaRows: prevState.areaRows,
                        factorDesperdicio: prevState.factorDesperdicio
                    }
                }
            }), () => {
                this.closeAreaModal();
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let divCarrito = $("#tableDetProdPreventa");
        let rows = $("#IdDetProductoCarrito").find("tr");
        if (rows.length >= 6 && !this.state.isEditing && this.props.detalles.length !== prevProps.detalles.length)
            divCarrito.scrollTop(divCarrito.prop("scrollHeight"));
    }

    render() {
        return (
            <>
                <table className="table table-hover d-block" style={{ minHeight: '300px' }}>
                    <thead>
                        <tr>
                            <th
                                className="text-nowrap"
                                style={{
                                    fontSize: "18px",
                                    backgroundColor: "#01A59C",
                                    color: "white",
                                    width: "23%",
                                }}
                            >
                                CANTIDAD
                            </th>
                            <th
                                className="text-nowrap"
                                style={{
                                    fontSize: "18px",
                                    backgroundColor: "#01A59C",
                                    color: "white",
                                    width: "23%",
                                }}
                            >
                                / PRECIO
                            </th>
                            <th
                                className="text-nowrap"
                                style={{
                                    fontSize: "18px",
                                    backgroundColor: "#01A59C",
                                    color: "white",
                                    width: "23%",
                                }}
                            >
                                / TOTAL
                            </th>
                            <th
                                style={{
                                    fontSize: "18px",
                                    backgroundColor: "#01A59C",
                                    color: "white",
                                    width: "31%",
                                }}
                            ></th>
                        </tr>
                    </thead>
                    <tbody id="">
                        {(() => {
                            const groupedDetalles = [];
                            const recetasGrouped = {};

                            this.props.detalles.forEach(det => {
                                if (det.grupoRecetaId) {
                                    if (!recetasGrouped[det.grupoRecetaId]) {
                                        recetasGrouped[det.grupoRecetaId] = {
                                            isGrupoReceta: true,
                                            grupoRecetaId: det.grupoRecetaId,
                                            recetaInfo: det.recetaInfo,
                                            items: [],
                                            total: 0
                                        };
                                        groupedDetalles.push(recetasGrouped[det.grupoRecetaId]);
                                    }
                                    recetasGrouped[det.grupoRecetaId].items.push(det);
                                    recetasGrouped[det.grupoRecetaId].total += (det.total || 0);
                                } else {
                                    groupedDetalles.push(det);
                                }
                            });

                            return groupedDetalles.map((det) => {
                                if (det.isGrupoReceta) {
                                    return (
                                        <tr key={`grupo-${det.grupoRecetaId}`} style={{ backgroundColor: '#e6f4ea' }}>
                                            <td colSpan={4} style={{ maxWidth: '1em' }}>
                                                <div className="d-flex justify-content-between align-items-center p-2">
                                                    <div>
                                                        <span className="font-weight-bold" style={{ color: '#01a59c', fontSize: '15px' }}>
                                                            <i className="fas fa-cubes mr-2"></i>
                                                            {det.recetaInfo?.Nombre || 'Ventana'}
                                                            <span className="ml-2 badge badge-info">W: {det.recetaInfo?.W}m</span>
                                                            <span className="ml-1 badge badge-info">H: {det.recetaInfo?.H}m</span>
                                                        </span>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <span className="font-weight-bold mr-4" style={{ fontSize: '16px' }}>
                                                            S/ {extractTwoDecimalsForNumber(det.total)}
                                                        </span>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-info mr-2"
                                                            onClick={() => this.props.onOpenRecetaDetails && this.props.onOpenRecetaDetails(det)}
                                                        >
                                                            <i className="fas fa-search mr-1"></i> Detalles
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => this.props.RemoveGrupoRecetaInList && this.props.RemoveGrupoRecetaInList(det.grupoRecetaId)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }

                                const style = {
                                    backgroundColor: det.IdTipoStock === TIPO_STOCK.CON_COMPROBANTE ? "" : "#f78b2d",
                                };

                                return (
                                    <React.Fragment key={`det-frag-${det.IdPresentacion}`}>
                                        <tr
                                            key={`det-head-${det.IdPresentacion}`}
                                            style={style}
                                            onKeyUp={(e) => this.props.onSecretKeyPress(e, det)}
                                        >
                                            <td colSpan={4} style={{ maxWidth: '1em' }}>
                                                <div className="d-flex justify-content-between">
                                                    <span>{det.descripcion} {det.unidadMedida}</span>
                                                    <div>
                                                        <select
                                                            required
                                                            disabled={this.props.load}
                                                            className="mt-1 mr-1"
                                                            value={det.Precio}
                                                            onChange={(e) => this.props.PrecioChange(e, det)}
                                                        >
                                                            <option value={det.PrecioMenor}>Menor/Lista</option>
                                                            <option value={det.PrecioFamiliar}>Familiar</option>
                                                            <option value={det.PrecioEspecial}>Especial</option>
                                                        </select>
                                                        <span>Precio Costo:
                                                            {det.PrecioCosto.toLocaleString("en-GB", {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2,
                                                            })}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr key={`det-body-${det.IdPresentacion}`}>
                                            <td className="p-0 border-0">
                                                <input
                                                    onClick={(e) => {
                                                        e.target.select();
                                                    }}
                                                    readOnly={this.props.load}
                                                    type="number"
                                                    style={{ backgroundColor: "rgb(53,96,90,0.18)" }}
                                                    step="1"
                                                    min="1"
                                                    name="Cantidada"
                                                    value={det.cantidad}
                                                    className="inputCantidadDet pr-2 h-auto"
                                                    onChange={(e) =>
                                                        this.props.InputCantidadDetalleChange(e, det)
                                                    }
                                                    onBlur={(e) => this.props.onBlurInputCantidad(e, det)}
                                                />
                                            </td>
                                            <td className="p-0 border-0">
                                                <input
                                                    onClick={(e) => {
                                                        e.target.select();
                                                    }}
                                                    readOnly={this.props.load}
                                                    type="number"
                                                    style={{ backgroundColor: "#01a59c", color: "white" }}
                                                    step="1"
                                                    min="0"
                                                    value={extractTwoDecimalsForNumber(det.precioVenta)}
                                                    onChange={(e) =>
                                                        this.props.InputPrecioVentaChange(e, det)
                                                    }
                                                    name="PrecioVenta"
                                                    className="inputPrecioVentaDet pr-2 h-auto"
                                                    onBlur={(e) => this.props.onBlurPrecioVenta(e, det)}
                                                />
                                            </td>
                                            <td className="p-0 border-0 text-white text-right pt-1 " style={{ backgroundColor: "#034b2f" }}>
                                                <span className="pr-2 h-auto">{det.Simbolo} {extractTwoDecimalsForNumber(det.total)}</span>
                                            </td>
                                            <td className="p-0 border-0">
                                                <div className="d-flex justify-content-end">
                                                    <BotonMenosPequeño
                                                        disabled={this.props.load}
                                                        className="ml-2"
                                                        type="button"
                                                        title="Disminuir en 1"
                                                        onClick={() => this.props.RestarCantidadDet(det)}
                                                    />
                                                    <BotonAddPequeño
                                                        disabled={this.props.load}
                                                        className="ml-2"
                                                        type="button"
                                                        title="Aumentar en 1"
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            this.props.AgregarCantidadDet(det)
                                                        }}
                                                    />
                                                    {Boolean(det.in_medidas && det.in_medidas !== "0" && det.in_medidas !== 0) &&
                                                        <BotonMedirArea
                                                            disabled={this.props.load}
                                                            className="ml-2"
                                                            type="button"
                                                            title="Medir Área"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                this.openAreaModal(det)
                                                            }}
                                                        />
                                                    }
                                                    <BotonRemovePequeño
                                                        disabled={this.props.load}
                                                        className="ml-2"
                                                        type="button"
                                                        title="Quitar item"
                                                        onClick={() =>
                                                            this.props.RemoveProductoInList(det)
                                                        }
                                                    />

                                                    <BotonDown
                                                        disabled={this.props.load}
                                                        className="btn-sm ml-2"
                                                        type="button"
                                                        title="Descuento"
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            this.props.handleOpenModalDescuento(det)
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                );
                            });
                        })()}
                    </tbody>
                </table>
                <Modal isOpen={this.state.showAreaModal} onClose={this.closeAreaModal} title="Medidas">
                    {this.state.selectedAreaItem && (
                        <div className="mb-3 d-flex flex-wrap justify-content-between text-left" style={{ fontSize: "14px", backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "5px", gap: "10px" }}>
                            <div><strong>Producto:</strong> {this.state.selectedAreaItem.descripcion}</div>
                            <div className="d-flex align-items-center">
                                <strong>Factor desperdicio por lado cm:&nbsp;</strong>
                                <input type="number" className="form-control form-control-sm" disabled value={this.state.factorDesperdicio} onChange={this.handleFactorChange} style={{ width: "70px" }} />
                            </div>
                            <div><strong>Unidad de Medida:</strong> {this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas}</div>
                        </div>
                    )}

                    <div className="table-responsive">
                        {(() => {
                            const isPie = this.state.selectedAreaItem && (this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
                            return (
                                <table className="table table-bordered table-sm text-center" style={{ fontSize: "12px", verticalAlign: "middle" }}>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Cant.<br />(und)</th>
                                            <th>Ancho<br />(cm)</th>
                                            <th>Alto<br />(cm)</th>
                                            <th>Área<br />(Pie2)</th>
                                            <th>Área<br />(m2)</th>
                                            <th>Desperdicio<br />({isPie ? 'Pie2' : 'm2'})</th>
                                            <th>Precio</th>
                                            <th>Total</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.areaRows.map((row, index) => {
                                            const areaPie2 = calculateAreaPie2(row, this.state.factorDesperdicio);
                                            const areaM2 = calculateAreaM2(row, this.state.factorDesperdicio);
                                            const wastePie2 = calculateWastePie2(row, this.state.factorDesperdicio);
                                            const wasteM2 = calculateWasteM2(row, this.state.factorDesperdicio);

                                            const isPie = this.state.selectedAreaItem && (this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
                                            const precio = this.state.selectedAreaItem ? parseFloat(this.state.selectedAreaItem.PrecioVenta) || 0 : 0;

                                            const total = isPie ? areaPie2 * precio : areaM2 * precio;
                                            const desperdicio = isPie ? wastePie2 : wasteM2;

                                            return (
                                                <tr key={row.id}>
                                                    <td><input type="number" className="form-control form-control-sm" value={row.cantidad} onChange={(e) => this.handleRowChange(row.id, 'cantidad', e.target.value)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" value={row.ancho} onChange={(e) => this.handleRowChange(row.id, 'ancho', e.target.value)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" value={row.alto} onChange={(e) => this.handleRowChange(row.id, 'alto', e.target.value)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" readOnly value={areaPie2.toFixed(3)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" readOnly value={areaM2.toFixed(3)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" readOnly value={desperdicio.toFixed(2)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" value={precio} onChange={(e) => {
                                                        const newPrecio = e.target.value;
                                                        if (this.props.InputPrecioVentaChange) {
                                                            this.props.InputPrecioVentaChange({ target: { name: 'PrecioVenta', value: newPrecio } }, this.state.selectedAreaItem);
                                                        }
                                                    }} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" readOnly value={total.toFixed(2)} /></td>
                                                    <td style={{ minWidth: "110px" }}>
                                                        <div className="d-flex justify-content-center align-items-center" style={{ gap: "5px" }}>
                                                            <button type="button" className="btn btn-danger btn-sm" title="Eliminar fila" onClick={() => this.handleRemoveRow(row.id)} disabled={this.state.areaRows.length === 1}>
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    <tfoot className="table-active font-weight-bold">
                                        <tr>
                                            <td colSpan="3" className="text-right">Sumas Totales:</td>
                                            <td>
                                                {this.state.areaRows.reduce((sum, row) => sum + calculateAreaPie2(row, this.state.factorDesperdicio), 0).toFixed(3)}
                                            </td>
                                            <td>
                                                {this.state.areaRows.reduce((sum, row) => sum + calculateAreaM2(row, this.state.factorDesperdicio), 0).toFixed(3)}
                                            </td>
                                            <td>
                                                {this.state.areaRows.reduce((sum, row) => {
                                                    const isPie = this.state.selectedAreaItem && (this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
                                                    return sum + (isPie ? calculateWastePie2(row, this.state.factorDesperdicio) : calculateWasteM2(row, this.state.factorDesperdicio));
                                                }, 0).toFixed(2)}
                                            </td>
                                            <td></td>
                                            <td>
                                                {this.state.areaRows.reduce((sum, row, index) => {
                                                    const precio = this.state.selectedAreaItem ? parseFloat(this.state.selectedAreaItem.PrecioVenta) || 0 : 0;
                                                    const isPie = this.state.selectedAreaItem && (this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
                                                    const rowTotal = isPie ? calculateAreaPie2(row, this.state.factorDesperdicio) * precio : calculateAreaM2(row, this.state.factorDesperdicio) * precio;
                                                    const newSum = sum + rowTotal;
                                                    if (row.ancho && row.alto) {
                                                        console.log(`[Cálculo Total Acumulado] Fila ${index + 1}: ${rowTotal} + Suma Anterior: ${sum} = Total Acumulado: ${newSum}`);
                                                    }
                                                    return newSum;
                                                }, 0).toFixed(2)}
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            );
                        })()}
                    </div>

                    <div className="mb-3 text-left">
                        <button type="button" className="btn btn-success btn-sm" onClick={this.handleAddRow}><i className="fas fa-plus"></i> Agregar Fila</button>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <button type="button" className="btn btn-danger mr-2" onClick={this.closeAreaModal}>Cancelar</button>
                        <button type="button" className="btn btn-verde-mfp" onClick={this.applyArea}>Aplicar Cantidad</button>
                    </div>
                </Modal>
            </>
        );
    }
}
